import {
  IAuditLogBase,
  IKeywords,
  IReport,
  IWorkflowItemStep,
} from '../../../../common/sharedTypes';
import * as urls from '../../../shared/urls';
import Api from '../../../../services/Api';
import { ApiResponse } from 'apisauce';
import { toast } from 'react-toastify';

// types
export enum ManagementActionTypes {
  UPDATE_KEYWORDS = '@@Managment/UpdateKeyowrds',
  SET_KEYWORDS = '@@Managment/SetKeywords',
  GET_LINK_REPORT = '@@Management/GetLinkKeywords',
  OPEN_REPORT = '@@Management/OpenReport',
}

export const CHANGE_ACTIVE_STATUS = 'CHANGE_ACTIVE_STATUS';

export const createManagementAuditLog = (
  reportLog: IAuditLogBase,
  logData: any
) => {
  return {
    ...reportLog,
    value: logData,
    type: CHANGE_ACTIVE_STATUS,
  };
};

export const saveManagement = (workflowItemStepId: number, data: any) => {
  return async (dispatch) => {
    try {
      await Api.post(urls.SAVE_MANAGEMENT_WORK, {
        workflowItemStepId,
        data: JSON.stringify(data),
      })
        .then((result: ApiResponse<any>) => {
          return Promise.resolve(result.data);
        })
        .catch((e) => {
          return Promise.reject(e);
        });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};

export const saveSplitCase = (keywords: IKeywords[]) => {
  return async (dispatch) => {
    try {
      await Api.post(urls.SAVE_MANAGEMENT_SPLIT, {
        keywords,
      })
        .then((result: ApiResponse<any>) => {
          if (result.ok && result.status == 200) {
            Promise.resolve(result);
          } else {
            Promise.reject(result);
          }
        })
        .catch((e) => {
          return Promise.reject(e);
        });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};

export const setKeywords = (keywords: IKeywords[]) => (dispatch) => {
  dispatch({
    type: ManagementActionTypes.SET_KEYWORDS,
    value: keywords,
  });
};

export const updateKeywords = (keywords: IKeywords) => (dispatch) => {
  dispatch({
    type: ManagementActionTypes.UPDATE_KEYWORDS,
    value: keywords,
  });
};

export const getKeywordsByCrashKey = (crashKey: string) => {
  return async (dispatch) => {
    try {
      await Api.get(urls.GET_REPORT_BY_CRASH_KEY + '?crashKey=' + crashKey)
        .then((result: ApiResponse<any>) => {
          if (result.ok) {
            dispatch(reduceLinkReport(result.data));
            Promise.resolve(result);
          } else {
            Promise.reject(result);
          }
        })
        .catch((e) => {
          return Promise.reject(e);
        });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};

export const reduceLinkReport = (report: IReport) => {
  return {
    type: ManagementActionTypes.GET_LINK_REPORT,
    value: report,
  };
};

export const openReport = (workflowItemStepId: number) => {
  return async (dispatch) => {
    try {
      await Api.post(urls.GET_WORKFLOW_ITEM_STEP, {
        workflowStepItemId: workflowItemStepId,
      }).then((result: ApiResponse<any>) => {
        dispatch(view(result.data));
        if (result.data == null) {
          toast.error('Error opening');
          return Promise.reject(result.data);
        }
        return Promise.resolve(result.data);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};

export const view = (workflowItemStep: IWorkflowItemStep) => {
  return {
    type: ManagementActionTypes.OPEN_REPORT,
    value: workflowItemStep,
  };
};
